import { splitLines } from '../detect.js';
const CLASS_BLOCK_RE = /^\s*class\s+(\S+)\s*\{([\s\S]*?)\}\s*$/;
const RELATION_RE = /^\s*(\S+?)\s*(<\|--|--\|>|\*--|--\*|o--|--o|\.\.>|<\|\.\.|\.\.\|>|\.\.\||--|>--|<--|\.\.|\|--\|\.\.|\.\.\||-->|<--|\|-->|<--\||\.\.>)\s*(\S+?)(?:\s*:\s*(.+))?\s*$/;
const parseMember = (raw) => {
    const m = /^([+\-#~])?\s*(\S+)\s*(?:\((.+)\))?$/.exec(raw.trim());
    if (!m)
        return { name: raw.trim(), type: 'field' };
    return {
        name: (m[3] ?? m[2] ?? raw.trim()).trim(),
        type: m[1] === '+' ? 'public' : m[1] === '-' ? 'private' : m[1] === '#' ? 'protected' : 'public',
    };
};
export const parseClassDiagram = (source) => {
    const lines = splitLines(source);
    const nodes = new Map();
    const edges = [];
    for (const raw of lines) {
        const line = raw.trim();
        if (!line || /^classDiagram/i.test(line))
            continue;
        const block = CLASS_BLOCK_RE.exec(line);
        if (block) {
            const name = block[1];
            const body = block[2] ?? '';
            const members = body
                .split(/[\n;]/)
                .map((s) => s.trim())
                .filter(Boolean)
                .map(parseMember);
            nodes.set(name, {
                id: name,
                label: name,
                shape: 'rect',
                members,
            });
            continue;
        }
        const rel = RELATION_RE.exec(line);
        if (rel) {
            const [, from, op, to, label] = rel;
            const style = op?.includes('<') ? 'dashed' : 'solid';
            edges.push({
                id: `e_${edges.length}_${from}_${to}`,
                from: from,
                to: to,
                label: label?.trim() || undefined,
                style,
            });
            if (!nodes.has(from))
                nodes.set(from, { id: from, label: from, shape: 'rect', members: [] });
            if (!nodes.has(to))
                nodes.set(to, { id: to, label: to, shape: 'rect', members: [] });
            continue;
        }
        // bare class declaration: `class Foo`
        const bare = /^\s*class\s+(\S+)\s*$/.exec(line);
        if (bare) {
            const id = bare[1];
            if (!nodes.has(id))
                nodes.set(id, { id, label: id, shape: 'rect', members: [] });
        }
    }
    // Encode members into the node label so they survive to the renderer.
    const finalNodes = Array.from(nodes.values()).map((n) => ({
        id: n.id,
        label: n.members.length
            ? `${n.id}\n${n.members.map((m) => `${m.type === 'public' ? '+' : m.type === 'private' ? '-' : '#'} ${m.name}`).join('\n')}`
            : n.id,
        shape: 'rect',
    }));
    return {
        type: 'class',
        nodes: finalNodes,
        edges,
        groups: [],
        styles: {},
        meta: { rawNodes: Array.from(nodes.values()) },
    };
};
//# sourceMappingURL=class.js.map